import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NumericInput as NumericInputCore } from '@blueprintjs/core';

const ElementWrapper = styled.div`
  display: flex;
`;

export default class NumericInput extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
  };

  handleOnChange = (value, valueStr) => {
    const tempValue = Number(valueStr);
    if (
      this.props.onChange &&
      typeof tempValue === 'number' &&
      !isNaN(tempValue)
    ) {
      this.props.onChange(valueStr);
    }
  };

  render() {
    const { label, ...otherProps } = this.props;
    return (
      <ElementWrapper>
        <NumericInputCore
          {...otherProps}
          minorStepSize={0.0001}
          onValueChange={this.handleOnChange}
        />
      </ElementWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/numeric-input/index.js